import {
  AfterViewInit,
  Component, ComponentRef,
  OnInit,
  QueryList, Type,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';
import {OverlayDirectiveDirective} from "./overlay-directive.directive";
import {DataService} from "../services/data.service";
import {OverlayService} from "./overlay.service";
import {OverlayComponentData} from "./overlay-component-data";
import {Overlayable} from "../interfaces/overlayable";
import {StoryComponent} from "../story/story/story.component";
import {Story} from "../interfaces/story";
import {DisplayService} from "../services/display.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements OnInit, AfterViewInit {

  // currentOverlays: OverlayComponentData[] = [];
  @ViewChildren(OverlayDirectiveDirective) directives!: QueryList<OverlayDirectiveDirective>;
  overlaysLength = 0;

  constructor(private viewContainerRef: ViewContainerRef, private data: DataService, private overlayService: OverlayService, private display: DisplayService) {
  }

  ngOnInit() {
    this.overlayService.onComponentAdded().pipe(untilDestroyed(this)).subscribe((component: OverlayComponentData) => {
      this.loadComponent(component);
    });
  }

  ngAfterViewInit() {
    this.overlaysLength = this.directives.length;
  }

  loadComponent(component: OverlayComponentData) {
    const newContainer = this.directives.last;
    if(newContainer) {
      component.componentRef = newContainer.viewContainerRef.createComponent(component.component, {
        index: 0
      });
      const htmlElement = component.componentRef.location.nativeElement as HTMLElement;
      this.display.disableBodyScroll([htmlElement]);
      const parentEl = htmlElement.querySelector("*") as HTMLElement;
      if(parentEl) {
        const id = component.id ?? 0;
        parentEl.style.zIndex = (id + 1000).toString();
      }

      for(const key in component.data) {
        component.componentRef?.setInput(key, component.data[key]);
      }
      const cref = component.componentRef as ComponentRef<Overlayable>;
      cref.instance.onClosed.pipe(untilDestroyed(this)).subscribe(() => {
        this.overlayService.removeComponent(component.id ?? -1);
      })
      newContainer.changeDetectorRef.detectChanges();
    }

  }

}
